import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import Cookies from 'js-cookie';
import { environment } from 'environments/environment';

// Configuration constants go here
// TODO: Read this from a JSON file
@Injectable()
export class Configuration {

    private static _headers: Headers = new Headers();

    private static _uploadHeaders: Headers = new Headers({});

    get apiUrl(): string {
        return environment.production ? `https://www.valmusterp.com/api` : `https://dev.valmusterp.com/api`;
    }

    get headers(): Headers {
        return Configuration._headers;
    }

    get uploadHeaders(): Headers {
        return Configuration._uploadHeaders;
    }

    public getStorage(key: string): string {
        if (window.localStorage) {
            return window.localStorage.getItem(key);
        }
    }

    public getCookie(key: string): string {
        if(Cookies) {
            return Cookies.get(key);
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/app.constants.ts